import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { GanttSegment, ParameterValueType } from '../gantt.models';
import { MatList, MatListItem } from '@angular/material/list';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MatIconButton } from '@angular/material/button';
import { DateFormatOptions } from '@jsverse/transloco-locale';
import { DateUtil } from '../../../../util/DateUtil';
import dayjs from 'dayjs';
import { NumberUtil } from '../../../../util/NumberUtil';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'ara-overlap-dialog',
	templateUrl: './overlap-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogTitle, MatDialogContent, MatList, MatListItem, TranslocoDirective, MatIconButton, MatIcon, CdkDrag, CdkDragHandle],
})
export class OverlapDialogComponent {
	dialogRef = inject<MatDialogRef<OverlapDialogComponent>>(MatDialogRef);
	data = inject<{
		segments: GanttSegment[];
		parameterValueType: ParameterValueType;
	}>(MAT_DIALOG_DATA);

	private dateUtil = inject(DateUtil);
	private numberUtil = inject(NumberUtil);
	private translocoService = inject(TranslocoService);

	onSegmentSelected(segment: GanttSegment): void {
		this.dialogRef.close(segment);
	}

	protected getValueString(segment: GanttSegment) {
		if ([ParameterValueType.TARIFF, ParameterValueType.PAYMENT, ParameterValueType.SHARE].includes(this.data.parameterValueType)) {
			return this.numberUtil.formatDecimal(Number(segment.value), 2) + ' €';
		}
		return segment.value;
	}

	protected getDatesString(segment: GanttSegment) {
		if (segment.from && segment.to && DateUtil.minDate.isSame(dayjs(segment.from), 'day') && DateUtil.maxDate.isSame(dayjs(segment.to), 'day')) {
			return this.translocoService.translate('billing.unlimited');
		} else if (segment.to && (!segment.from || DateUtil.minDate.isSame(dayjs(segment.from), 'day'))) {
			return this.translocoService.translate('common.until') + ' ' + this.dateUtil.setDateFormatByActiveLang(segment.to, '', false, true);
		} else if (segment.from && (!segment.to || DateUtil.maxDate.isSame(dayjs(segment.to), 'day'))) {
			return this.translocoService.translate('common.from2') + ' ' + this.dateUtil.setDateFormatByActiveLang(segment.from, '', false, true);
		}
		return `${this.dateUtil.setDateFormatByActiveLang(segment.from, '', false, true)} - ${this.dateUtil.setDateFormatByActiveLang(segment.to, '', false, true)}`;
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		event.preventDefault();
		this.dialogRef.close();
	}
}
